import { Dispatch } from 'redux';
import { api } from '../../service/api';
import { CLIENTS_ACTIONS } from './actions';

export const addClientGroup =
  (existingClientId, currentClientId) => (dispatch: Dispatch) => {
    api.addClientGroup(existingClientId, currentClientId).then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.ADD_CLIENT_GROUP,
        payload: res.data,
      });
    });
  };

export const existingClientGroup =
  (GroupId, currentClientId) => (dispatch: Dispatch) => {
    api.existingClientGroup(GroupId, currentClientId).then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.EXISTING_CLIENT_GROUP,
        payload: res.data,
      });
    });
  };

export const removeClientFromGroup =
  (clientId, groupId) => (dispatch: Dispatch) => {
    api.removeClientFromGroup(clientId, groupId).then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.REMOVE_CLIENT_FROM_GROUP,
        payload: res.data,
      });
    });
  };

export const addUserToGroup = (userId, clientId) => (dispatch: Dispatch) => {
  api.addUserToGroup(userId, clientId).then((res) => {
    dispatch({
      type: CLIENTS_ACTIONS.ADD_USER_TO_GROUP,
      payload: res.data,
    });
  });
};

export const removeUserFromGroup =
  (userId, clientId) => (dispatch: Dispatch) => {
    api.removeUserFromGroup(userId, clientId).then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.REMOVE_USER_FROM_GROUP,
        payload: res.data,
      });
    });
  };

export const editClientGroup = (body) => (dispatch: Dispatch) => {
  api.editClientGroup(body).then((res) => {
    dispatch({
      type: CLIENTS_ACTIONS.EDIT_CLIENT_GROUP,
      payload: res.data,
    });
  });
};

export const getClientGroupOptions = () => (dispatch: Dispatch) => {
  api.getClientGroupOptions().then((res) => {
    dispatch({
      type: CLIENTS_ACTIONS.GET_CLIENT_GROUP_OPTIONS,
      payload: res.data,
    });
  });
};

export const getClientUserList = () => (dispatch: Dispatch) => {
  api.getClientUserList().then((res) => {
    dispatch({
      type: CLIENTS_ACTIONS.GET_CLIENT_USER_LIST,
      payload: res.data,
    });
  });
};

export const getClientGroupList = () => (dispatch: Dispatch) => {
  api.getClientGroupList().then((res) => {
    dispatch({
      type: CLIENTS_ACTIONS.GET_CLIENT_GROUP_LIST,
      payload: res.data,
    });
  });
};
